/*
 * One glyph per destination, shared by everything that lists those destinations — the navbar, the
 * admin nav and the command palette. A palette row for Products that does not look like the
 * navbar's Products reads as a second, different thing.
 */
import productsIcon from '@icons/other/tags.svg';
import componentsIcon from '@icons/other/button.svg';
import samplesIcon from '@icons/other/samples.svg';
import ordersIcon from '@icons/other/box.svg';
import suppliersIcon from '@icons/filters-icons/suppliers.svg';
import colorsIcon from '@icons/other/color-filled.svg';
import measurementsIcon from '@icons/custom-fields/product-measurements.svg';
import adminIcon from '@icons/other2/settings-small.svg';
import brandIcon from '@icons/miscellaneous/office-building.svg';

export const navIcons = {
  products: productsIcon,
  components: componentsIcon,
  samples: samplesIcon,
  orders: ordersIcon,
  suppliers: suppliersIcon,
  colors: colorsIcon,
  measurements: measurementsIcon,
  admin: adminIcon,
  brand: brandIcon,
};

/**
 * button.svg is drawn inside its own padding and covers 78% of its viewBox, so at a box shared with
 * icons that fill theirs it reads a size smaller. The navbar and the admin nav correct it by the
 * same factor; anything else drawing it at that shared size needs the same.
 */
export const componentsIconScale = 1.277;
